import getConfig from 'next/config';

const {publicRuntimeConfig} = getConfig();
const {reloadTime} = publicRuntimeConfig;
const timer = reloadTime * 0.75 + Math.round(Math.random() * reloadTime * 0.5);
let timeoutId;

const reloadPage = () => window.location.reload(true);

const addListeners = () => {
    window.addEventListener('mousemove', resetListeners);
    window.addEventListener('keypress', resetListeners);
    window.addEventListener('touchstart', resetListeners);
};

const resetListeners = () => {
    window.removeEventListener('mousemove', resetListeners);
    window.removeEventListener('keypress', resetListeners);
    window.removeEventListener('touchstart', resetListeners);

    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(reloadPage, timer);

    window.setTimeout(addListeners, 10000);
};

const startReloadTimeout = () => {
    resetListeners();

    return new Promise((resolve) => {
        window.setTimeout(resolve, timer);
    });
};

export {startReloadTimeout};
